import { Rows } from 'common/types/scalarSpreadsheet';
import { BOLD_DIVISION_ROW_HEADER_CONFIG } from 'pages/Valuations/approaches/backsolveApproach/constants';
import { SOURCE_ROWS_TABLE_TARGET_PRICE_TITLE } from '../constants';
import { getSourceRowKey } from '../getSourceRowKey';
import { SOURCE_ROWS_TABLE_HEADER, SOURCE_TOTALS_ROW } from '../sheetAliases';
import { CustomRowConfigParams } from './types';

const customRowConfig = ({ rows, isDisabled }: CustomRowConfigParams): Rows => [
  {
    alias: SOURCE_ROWS_TABLE_HEADER,
    ignoreRowCopy: true,
    readOnly: true,
  },
  ...rows.map((row, index) => ({
    alias: `SOURCE_ROW_${getSourceRowKey(row, index)}`,
    ignoreRowCopy: true,
    readOnly: isDisabled,
    value: row.title,
  })),
  {
    alias: SOURCE_TOTALS_ROW,
    className: `${BOLD_DIVISION_ROW_HEADER_CONFIG.className} division-top-only`,
    ignoreRowCopy: true,
    readOnly: true,
    value: SOURCE_ROWS_TABLE_TARGET_PRICE_TITLE,
  },
];

export default customRowConfig;
